import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { faCartPlus, faSave } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@tosize/ui";
import { useIntl } from "react-intl";
import { useAddToCartContext } from "../../../context/AddToCartContext";
import { useConfig } from "../../../context/ConfigContext";

export function FloatingSave() {
	const { mode } = useConfig();
	const intl = useIntl();
	const { onAddToCartClick, isDisabled, isLoading } = useAddToCartContext();

	if (mode === "add") {
		return null;
	}

	return (
		<div className="md:-translate-y-1/2 fixed top-1/2 right-[calc(min(var(--dialog-x),100%)-3rem)] z-9 rounded-r-full bg-white shadow-sm md:right-[calc(var(--dialog-x)-1.5rem)] md:left-auto md:rounded-full md:bg-shades-light md:shadow-none">
			<button
				type="submit"
				title={intl.formatMessage({ defaultMessage: "Aanpassingen opslaan" })}
				className={cn(
					"flex h-12 w-12 appearance-none items-center justify-center rounded-full border-[5px] border-white bg-success text-white outline-none hover:bg-success-medium focus-visible:bg-success-medium disabled:cursor-not-allowed disabled:bg-success/70 hover:disabled:bg-success/70 motion-safe:transition-colors md:border-shades-light",
					{ "cursor-not-allowed opacity-70": isLoading },
				)}
				onClick={onAddToCartClick}
				disabled={isDisabled}
			>
				<FontAwesomeIcon
					icon={
						isLoading
							? faSpinnerThird
							: mode === "editCartItem" || mode === "editProjectItem"
								? faSave
								: faCartPlus
					}
					className={cn({ "motion-safe:animate-spin": isLoading })}
					fixedWidth
				/>
			</button>
		</div>
	);
}
